<div class="copoun-wrapper">
    <div class="get-coupon-btn" (click)="displayCouponCode()"
        *ngIf="couponService.listOfAvailbleCoupons!=null && couponService.listOfAvailbleCoupons.length>0">
        <span>
            לחץ לקבלת קופון
            <div class="copun-btn-txt-internal">
                לחץ לקבלת קופון
            </div>

        </span>

    </div>
</div>